import axios from 'axios';
import jwtDecode from 'jwt-decode';

export default {
  state: {
    jwt: localStorage.getItem('jwt'),
    user: localStorage.getItem('jwt') ? jwtDecode(localStorage.getItem('jwt')) : null,
  },
  actions: {},
  mutations: {
    update(rootState, { state, property, value }) {
      state[property] = value;
    },
  },
};